export const MENU_PUBLIC_ITEMS_COLORS = [
  "brandPrimary.500",
  "brandSecondary.500",
  "#F17E00",
  "#96180C",
];
